export const CARRIERS = 'CARRIERS';
export const SELCTED_CARRIER = 'SELCTED_CARRIER';
export const APP_CARRIER_BUSY = 'APP_CARRIER_BUSY';
